/** Audit surface shared helpers. Ported from prototype stage-audit.jsx. */
import { fmtEur } from "../../lib/format";
import type { DiscrepancyStatus, DiscrepancyType } from "../../lib/tenderApi";

export { fmtEur };

export type ResolutionStatus = "Risolto" | "In revisione" | "Non risolto";

export function discrepancyTypeLabel(t: DiscrepancyType): string {
  return {
    qty_mismatch: "Quantità divergente",
    price_mismatch: "Prezzo fuori range",
    desc_mismatch: "Descrizione divergente",
  }[t];
}

/** Backend has 4 discrepancy states; the UI has 3 buttons. `open` and
 * `unresolved` both read as "Non risolto"; the write maps "Non risolto" →
 * `unresolved` (the explicit not-resolved state). */
export function statusFromBackend(s: DiscrepancyStatus): ResolutionStatus {
  if (s === "resolved") return "Risolto";
  if (s === "in_review") return "In revisione";
  return "Non risolto"; // open | unresolved
}

export function statusToBackend(s: ResolutionStatus): DiscrepancyStatus {
  if (s === "Risolto") return "resolved";
  if (s === "In revisione") return "in_review";
  return "unresolved";
}

export function statusBg(s: ResolutionStatus): string {
  return {
    Risolto: "var(--c-ok-soft)",
    "In revisione": "var(--c-info-soft)",
    "Non risolto": "var(--c-err-soft)",
  }[s];
}

export function statusFg(s: ResolutionStatus): string {
  return { Risolto: "var(--c-ok)", "In revisione": "var(--c-info)", "Non risolto": "var(--c-err)" }[
    s
  ];
}

export interface Comment {
  text: string;
  ai: boolean;
  time: string;
  author: string;
}
